import mobileCarousel from '../utils/mobileCarousel';

mobileCarousel(
    'esg-pages__mobile-carousel',
    'swiper-pagination-esg-pages',
    1.2,
    16,
    false
);
